<template>

  <div class="page-table">
    <vxe-grid
      border="inner"
        :columns="columns"
        auto-resize
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        id="id"
        :data="data"
        show-overflow
        :empty-render="{name: 'NotData'}"
        size="small"
        :loading="loading"
    >
       <template #status="{row}">
					<div :class="statusEnum(row.status).class">{{statusEnum(row.status).text}}</div>
				</template>
        <template #handle="{row}">
					<div class="table-handle-btn" v-if="row.status === 1">
            <a-tooltip placement="top" title="查看">
              <icon-font @click="viewClick(row)" class="view-btn mr-16" type="icon-Eye-Open"/>
            </a-tooltip>
            <a-tooltip placement="top" title="复制">
              <icon-font @click="copyClick(row)" class="copy-btn mr-16" type="icon-Copy"/>
            </a-tooltip>
						<a-tooltip placement="top" title="编辑" v-if="row.permission&&row.permission.indexOf('w') > -1">
              <icon-font @click="editClick(row)" class="edit-btn" type="icon-Edit"/>
            </a-tooltip>
					</div>
				</template>
    </vxe-grid>
    <a-pagination
        class="mt-16 mb-16 df-end"
        size="small"
        v-if="(data &&data.length > 0)"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        :current="pagination.current"
        @change="(page, pageSize) => handleTableChange(page,pageSize)"
      />
  </div>
</template>
<script>
import {  systemShareList, shareModalList } from "@/api/shareModal"
import { copyBaseTemplate, validExclusive } from '@/api/template'

const defColumns = [
	{
		title: '模型名称',
		field: 'templateName',
		align: 'left',
		// width: 180,
	},
  {
		title: '分享人',
		field: 'username',
		align: 'left',
		// width: 120,
	},
	{
		title: '分享部门',
		field: 'orgName',
		align: 'left',
		// width: 160,
	},
  {
    title: '状态',
    field: 'status',
    align: 'left',
    width: 130,
    slots: { default: 'status' },
  },
	{
		title: '创建时间',
		field: 'createTime',
		align: 'left',
		// width: 180,
	},
  {
		title: '更新时间',
		field: 'updateTime',
		align: 'left',
		// width: 180,
	},
  {
		title: '操作',
		field: 'handle',
		align: 'left',
		slots: { default: 'handle' },
		width: 150,
	},
]
const innerColumns = [
	{
		title: '模型名称',
		field: 'templateName',
		align: 'left',
		// width: 180,
	},
  {
		title: '分享人',
		field: 'username',
		align: 'left',
		// width: 120,
	},
	{
		title: '分享部门',
		field: 'orgName',
		align: 'left',
		// width: 160,
	},
  {
    title: '状态',
    field: 'status',
    align: 'left',
    width: 130,
    slots: { default: 'status' },
  },
	{
		title: '创建时间',
		field: 'createTime',
		align: 'left',
		// width: 180,
	},
  {
		title: '操作',
		field: 'handle',
		align: 'left',
		slots: { default: 'handle' },
		width: 150,
	},
]
export default {
  data() {
    return {
      loading: false,
      pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},      
			data: [],
			columns: defColumns,
      tableList: [],
      searchParams: {
        name: undefined,
        userEmail: ''
      }
    };
  },
  props:{
    tabKey: {
      type: String,
      required: true,
    }
  } ,
  watch:{
    tabKey(val){
      console.log(val, '------')
      this.columns = this.tabKey === 'default'?defColumns:innerColumns
    }
  },
  mounted() {
    // this.getList();
    this.columns = this.tabKey === 'default'?defColumns:innerColumns
  },
  methods: {
    statusEnum(text) {
			let obj = this.$enum.SHARE_STATUS[text] || { class: "", text: "" }
			return obj
		},
    
    getList(searchParams, current) {
      this.loading = true
      if(searchParams){
        this.searchParams = searchParams;
      }
      const params = {
        pageSize: this.pagination.pageSize,
        pageNo: current ? current : this.pagination.current,
        templateName: this.searchParams.name ,
        userEmail:  this.searchParams.userEmail 
      }
      console.log(this.tabKey)
      let api = this.tabKey === 'default' ? systemShareList : shareModalList;
      api(params).then((res) => {
        console.log(res,'res');
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleTableChange(page) {
			let pager = { ...this.pagination, current:page };
			 
			this.pagination = pager;
			this.getList()
		},
    copyClick(record) {
			this.loading = true
			copyBaseTemplate(record.templateId).then(res => {
				gtag('event', 'share_model_copy_internal', {
					modelName: record.name,
				});
				this.editClick({
					templateId: res.data
				})
			}).finally(() => this.loading = false)
    },
    editClick(record) {
			validExclusive(record.templateId).then(res => {
				this.$router.push({
					name: 'modelDesign',
					query: {
						reportCode: record.templateId,
						name: record.name
					}
				})
			})
		},
    viewClick(record) {
			gtag('event', 'share_model_view_internal', {
				modelName: record.name,
			});
      let routeUrl = this.$router.resolve({
        path: "/multiplePermissions",
        query: { 
					reportCode: record.id,
					backUrl: location.href
				}
      });
      window.open(routeUrl.href, "_blank");
		},
    

  },
  
};
</script>
<style lang="less" scoped>
	.edit-btn, .delete-btn, .copy-btn {
		margin-left: 16px;
	}
	.view-btn,.copy-btn, .edit-btn, .delete-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
  .success {
		line-height: 22px;
		background: #F2FAF3;
		border-radius: 4px;
		font-size: 12px;
		color: #22AC35;
		padding: 0 8px;
		display: inline-block;
	}
  .cancel {
		line-height: 22px;
		background: #F3F6FE ;
		border-radius: 4px;
		font-size: 12px;
		color: #677392;
		padding: 0 8px;
		display: inline-block;
	}
  .page-tabs {
		// margin-top: 24px;
		padding-left: 24px;
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
</style>